<h2 mat-dialog-title>Gerar link de planos</h2>

<mat-dialog-content class="content">
  <div class="info">
    <div class="account">{{ data?.accountName }}</div>
    <div *ngIf="hasActiveSignature" class="warn">
      Você deseja realmente gerar um link? Esta conta já possui um plano ativo.
    </div>

  </div>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Escolha o plano</mat-label>
    <mat-select [(value)]="selectedPlanId">
      <mat-option *ngFor="let p of plans" [value]="p.id">
        {{ p.name }} — {{ p.price | currency }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button class="btn-close" (click)="close()">
    <fa-icon icon="times"></fa-icon>
    Fechar
  </button>

  <button mat-flat-button class="btn-open" [disabled]="!selectedPlan" (click)="openLink()">
    <fa-icon icon="external-link-alt"></fa-icon>
    Abrir link
  </button>

  <button mat-stroked-button class="btn-copy" [disabled]="!selectedPlan" (click)="copyLink()">
    <fa-icon icon="copy"></fa-icon>
    Copiar link
  </button>
</mat-dialog-actions>